import React from 'react';
import { Home, ListTodo, Calendar, ShoppingCart, BarChart3 } from 'lucide-react';

export function BottomNav({ theme, view, onChange }) {
  const tabs = [
    { id: 'dashboard', label: 'I dag', icon: Home },
    { id: 'tasks', label: 'Opgaver', icon: ListTodo },
    { id: 'calendar', label: 'Kalender', icon: Calendar },
    { id: 'shopping', label: 'Indkøb', icon: ShoppingCart },
    { id: 'stats', label: 'Stats', icon: BarChart3 },
  ];

  return (
    <nav style={{
      position: 'fixed',
      bottom: 0, left: 0, right: 0,
      background: theme.bgElevated,
      borderTop: `1px solid ${theme.border}`,
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      paddingBottom: 'env(safe-area-inset-bottom, 0)',
      zIndex: 50,
    }}>
      {tabs.map(t => {
        const Icon = t.icon;
        const active = view === t.id;
        return (
          <button key={t.id} onClick={() => onChange(t.id)} style={{
            background: 'transparent',
            border: 'none',
            padding: '10px 4px',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            color: active ? theme.coral : theme.textMuted,
            fontSize: 10,
            fontWeight: active ? 600 : 500,
          }}>
            <Icon size={20} />
            <span>{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
